export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;
export const AVATAR_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;
/** Public path of a stored profile picture, or null for the default icon. */
export const avatarPath = (avatar: string | null | undefined) =>
  avatar ? '/avatars/' + avatar : null;
